import React, {
  ChangeEvent,
  DetailedHTMLProps,
  forwardRef,
  InputHTMLAttributes,
  KeyboardEvent,
} from 'react'

import style from './Search.module.css'

import { ReactComponent as CrossIcon } from 'assets/icons/cross-icon.svg'

type DefaultInputPropsType = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>

type PropsType = DefaultInputPropsType & {
  value: string
  clearButtonHandler: () => void
  label?: string
  onChangeText?: (value: string) => void
  onEnter?: () => void
  className?: string
}

export const Search = forwardRef<HTMLInputElement, PropsType>(
  (
    {
      value = '',
      label,
      clearButtonHandler,
      onChangeText,
      onEnter,
      onKeyDown,
      className,
      ...props
    },
    ref
  ) => {
    const onChangeInputHandler = (e: ChangeEvent<HTMLInputElement>) => {
      onChangeText && onChangeText(e.currentTarget.value)
    }

    const onKeyDownHandler = (e: KeyboardEvent<HTMLInputElement>) => {
      onKeyDown && onKeyDown(e)

      if (onEnter && e.key === 'Enter') {
        onEnter()
      }

      if (e.key === 'Escape') {
        clearButtonHandler()
      }
    }

    return (
      <div className={`${style.box} ${className ? className : ''}`}>
        <label>
          {label}
          <input
            className={`${style.input}`}
            type="text"
            ref={ref}
            value={value}
            onChange={onChangeInputHandler}
            onKeyDown={onKeyDownHandler}
            placeholder="CategoriesSearch"
            {...props}
          />
        </label>
        {value.length !== 0 && (
          <button
            onClick={clearButtonHandler}
            className={style['clear-button']}
            aria-label="очистить поиск"
          >
            <CrossIcon className={style.icon} />
          </button>
        )}
      </div>
    )
  }
)
